import React from 'react';

import type { OsType } from '../hooks/usePlatformInfo';

export interface CustomLinkActionProps {
  href: string;
  onClick?: (event: React.MouseEvent) => void | Promise<void>;
}

/** 앱 업데이트(플레이스토어) 버튼 클릭 */
export const getPlayStoreAction = ({
  osType,
  to,
}: {
  osType: OsType;
  to: string;
}): CustomLinkActionProps => {
  if (osType === 'Android' || osType === 'mWebAndroid') {
    return { href: to };
  }

  // Android가 아닌 경우 미동작
  return {
    href: 'javascript:;',
    onClick: (event) => event.preventDefault(),
  };
};

/** 앱 업데이트(앱스토어) 버튼 클릭 */
export const getAppStoreAction = ({
  osType,
  to,
}: {
  osType: OsType;
  to: string;
}): CustomLinkActionProps => {
  if (osType === 'iOS' || osType === 'mWebIOS') {
    return { href: to };
  }

  // iOS가 아닌 경우 미동작
  return {
    href: 'javascript:;',
    onClick: (event) => event.preventDefault(),
  };
};
